const mainTheme = {
    primary : '#255DC8',
    secondary: '#B3B9C2',
    white : '#FFFFFF',
    light: '#F8F8FB',
    inputBg: '#F7F7FA',
    lightGrey: '#CECBDE',
    blue: '#255DC8',
    darkblue: '#151c81',
    success: '#27AE60',
    progress: '#021160',
    textBlack: '#030303',
    textLight: '#B3B9C2',
    textOrange: '#FFB701',
    textBlue: '#255DC8',
    price: '#EB5757',
    successDisable: '#D2FFE5'
}

export default mainTheme